<template>
  <div>
    <div class="search-boxs">
      <input type="text" placeholder="Buscar..." />
      <span class="icon">&#128269;</span>
    </div>

    <div class="panel-titles">
      <div class="panel-header">
        <span class="title">Data</span>
        <span class="title">Titulo</span>
        <span class="title">Gerado em</span>
        <span class="title">Ações</span>
      </div>
      <hr />
      <div class="panel-contents">
        <div class="data">26/04/2024</div>
        <hr />
      </div>
    </div>
  </div>
</template>

<script>
import Layout from './Layout.vue'
export default {
  layout: Layout,
}
</script>

<style>
.search-boxs {
  position: absolute;
  right: 10px;
  top: 10px;
  width: 300px;
  height: 40px;
}
.search-boxs input[type='text'] {
  width: 100%;
  height: 100%;
  padding: 10px 20px 10px 40px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 10px;
}
.search-boxs .icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  font-size: 20px;
  color: #ccc;
}
.panel-titles {
  width: 100%;
  background-color: white;
  height: 200px;
}

.panel-header {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  padding: 10px 20px;
}
.panel-contents {
  padding: 10px;
}

.data,
.titulo,
.gerado,
.acoes {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
</style>
